import type {ButtonAppearance} from '@Components/button';
import {ButtonType, ButtonVariant, LegacyButtonType} from '@Components/button';

export const CAROUSEL_SCROLL_EDGE_TOLERANCE_PX = 1;

export type ConfirmationCarouselBackground = 'greenBackground' | 'yellowBackground' | 'blueBackground' | 'purpleBackground';

export interface ConfirmationCarouselCard {
  title: string;
  subtext: string;
  ctaText: string;
  ctaAppearance: ButtonAppearance;
  ctaUri: string;
  ctaIcon: string;
  ctaClassName?: string;
  backgroundClass: ConfirmationCarouselBackground;
  imageFileName: string;
}

export const getConfirmationCarouselCards = (): ConfirmationCarouselCard[] => {
  return [
    {
      title: window.i18next.t('pmwjs_social_media_marketing'),
      subtext: window.i18next.t('pmwjs_set_and_forget_watch_the_likes_roll_in'),
      ctaText: window.i18next.t('pmwjs_publish_a_post'),
      ctaAppearance: {type: ButtonType.PRIMARY, variant: ButtonVariant.SUCCESS},
      ctaUri: 'socialmedia/post',
      ctaIcon: 'icon-social-media',
      backgroundClass: 'greenBackground',
      imageFileName: 'confirmation-carousel-social-media-marketing-2.png',
    },
    {
      title: window.i18next.t('pmwjs_event_promotion'),
      subtext: window.i18next.t('pmwjs_share_everywhere_attract_crowds'),
      ctaText: window.i18next.t('pmwjs_create_event_page'),
      ctaAppearance: {type: LegacyButtonType.PREMIUM3},
      ctaUri: 'event/wizard',
      ctaIcon: 'icon-event',
      backgroundClass: 'yellowBackground',
      imageFileName: 'confirmation-carousel-event-promotion-2.png',
    },
    {
      title: window.i18next.t('pmwjs_create_with_ai'),
      subtext: window.i18next.t('pmwjs_smart_ai_tools_quick_easy_time_saving'),
      ctaText: window.i18next.t('pmwjs_create_with_ai'),
      ctaAppearance: {type: ButtonType.PRIMARY, variant: ButtonVariant.AI},
      ctaUri: 'ai/chat',
      ctaIcon: 'icon-sparkle',
      backgroundClass: 'blueBackground',
      imageFileName: 'confirmation-carousel-create-with-ai-2.png',
    },
    {
      title: window.i18next.t('pmwjs_email_marketing'),
      subtext: window.i18next.t('pmwjs_own_the_inbox_send_track_convert'),
      ctaText: window.i18next.t('pmwjs_create_an_email'),
      ctaAppearance: {type: ButtonType.PRIMARY, variant: ButtonVariant.PREMIUM},
      ctaUri: 'email/templates',
      ctaIcon: 'icon-mail-sends',
      backgroundClass: 'purpleBackground',
      imageFileName: 'confirmation-carousel-email-marketing-2.png',
    },
  ];
};
